//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Component from '../../base/Component'

const NjBurger = Component.extend({
  name: 'NjBurger',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    fixedClasses: {
      type: [String, Array, Object],
      default: () => ({
        wrapper: 'nj-burger',
        button: 'relative block border-0 focus:outline-none',
        bar: ''
      })
    },
    classes: {
      type: [String, Array, Object],
      default: () => ({
        bar: 'bg-gray-800'
      })
    }
  },
  computed: {
    isOpenBurger: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    }
  }
})

export default NjBurger
